// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Substitua pelos dados de configuração do seu Firebase
const firebaseConfig = {
    apiKey: "AIzaSyA0uyktvRUEBMKClcJ7RzRm09_Zcc1zw6s",
    authDomain: "crmnext-af1b9.firebaseapp.com",
    projectId: "crmnext-af1b9",
    storageBucket: "crmnext-af1b9.firebasestorage.app",
    messagingSenderId: "535368674975",
    appId: "1:535368674975:web:c9df9d458c03e25c1a7caa",
    measurementId: "G-V3F5E83Q2Z",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
